import { deslocarMes } from './carteira-mes';

/** Busca da URL do fluxo de caixa: `de` e `ate` (AAAA-MM-DD) e `granularidade` (semana | mes). Invalido e descartado. */

export const GRANULARIDADES_FLUXO = ['semana', 'mes'] as const;
export type GranularidadeFluxo = (typeof GRANULARIDADES_FLUXO)[number];

const RE_DATA = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;

export function lerBuscaFluxo(bruto: Record<string, unknown>): { de?: string; ate?: string; granularidade?: GranularidadeFluxo } {
  const de = typeof bruto.de === 'string' && RE_DATA.test(bruto.de) ? bruto.de : undefined;
  const ate = typeof bruto.ate === 'string' && RE_DATA.test(bruto.ate) ? bruto.ate : undefined;
  const granularidade = GRANULARIDADES_FLUXO.find((g) => g === bruto.granularidade);
  return { ...(de ? { de } : {}), ...(ate ? { ate } : {}), ...(granularidade ? { granularidade } : {}) };
}

export const ROTULO_GRANULARIDADE: Record<GranularidadeFluxo, string> = { semana: 'Semana', mes: 'Mês' };

/** Periodo padrao do fluxo: do primeiro dia do mes `mes` ao ultimo dia de dois meses depois (so calendario). */
export function periodoPadraoFluxo(mes: string): { de: string; ate: string } {
  const [ano, m] = deslocarMes(mes, 2).split('-').map(Number) as [number, number];
  const ultimo = new Date(Date.UTC(ano, m, 0)).getUTCDate();
  return { de: `${mes}-01`, ate: `${ano}-${String(m).padStart(2, '0')}-${String(ultimo).padStart(2, '0')}` };
}
